import React, { lazy, Suspense } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const LazyLogin = lazy(() => import("./Login"));

const Login = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <GoogleOAuthProvider
      // Old clientId="923522293386-90krmg3r02442obilbvcvior4lqtl63j.apps.googleusercontent.com">
      clientId="349503787284-ns3fmdpfbrr1q78gntv8pglppfpidd9r.apps.googleusercontent.com"
    >
      <LazyLogin {...props} />
    </GoogleOAuthProvider>
  </Suspense>
);

export default Login;
